import React from 'react'
import './footer.css';
const Footer = () => {
  return (
<footer className='footer'>
by : Aya kamal
</footer>  

)
}
export default Footer;